import './styles/style.css'
import 'react-dates/lib/css/_datepicker.css'

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './config/store';
import App from './containers/App';
import PermissionModal from './modules/user/components/PermissionModal'

ReactDOM.render(
    <Provider store={store}>
        <App />
        <PermissionModal/>
    </Provider>, document.getElementById('root'));